import React, { FunctionComponent } from "react";
import classNames from "classnames";
import { Form, Radio } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";

// MULTI_CHOICE — pick exactly one option.
const RadioButton: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => (
  <Form.Item
    name={question.id}
    label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
    rules={[{ required: question.isRequired, message: "Please select one of the options" }]}
    className={classNames(styles.radioButtonInput, styles.disableRadioButtonInput)}
  >
    <Radio.Group disabled={disabled}>
      {(question.options || []).map(option => (
        <Radio key={option.value} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  </Form.Item>
);

export default RadioButton;
